export default __webpack_public_path__ + "static/media/lady-with-juice.436db294.png";